module.exports = require('@milo/config/config-public.json');
